import { Keyword } from '../../../domain/models';

export function getKeywordForHash(hash: string) {
	const keyword = decodeURIComponent(hash);

	if (!Object.values(Keyword).includes(keyword as Keyword)) {
		return undefined;
	}

	return keyword as Keyword;
}
